import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgFilter({
    token: Token.NumberFormateFilter,
    dependencies: [
    ]
})
export class NumberFormatFilter {
    constructor() {
        return ((
            value: number,
            format?: string,
            minPrecision?: number,
            maxPrecision?: number,
            currency?: string,
            decimalSeparator?: string,
            thousandsSeparator?: string,
            prefix?: string,
            suffix?: string) => {
            return value.format({
                formatType: format,
                minPrecision: Number(minPrecision),
                maxPrecision: Number(maxPrecision),
                currency,
                decimalSeparator,
                thousandsSeparator,
                prefix,
                suffix
            });
        } ) as any;
    }
}
